<template>
  <DotLottieVue ref="Service2" class="size-[200px] lg:size-[15vw]" autoplay :src="props.src" />
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    default: "",
  },
})

const Service2 = ref();

const initiateInterval = () => {
  setInterval(() => {
    if (Service2.value && import.meta.client) {
      const lottieInstance = Service2.value.getDotLottieInstance()
      lottieInstance.play()
    }
  }, 9200)
}

onMounted(() => {
  nextTick(() => {
    initiateInterval()
  })
})
</script>
